import * as React from 'react'
import { Box } from '@mui/material'
import { Paper } from '@mui/material'
import { LogoIcon } from 'shared/icons/LogoIcon'
import Divider from '@mui/material/Divider'
import { ApplicationMainToolbarContent } from 'shared/widgets/ApplicationMainToolbarContent'
import { callback } from 'chart.js/dist/helpers/helpers.core'
import { useDynamicMainToolbar } from 'shared/hooks/useMainToolbar'
import { useNavigate } from 'react-router-dom'
import { ImageSlider2 } from 'shared/ui/strspykit/ImageSlider2'

export interface AboutProps {
}

export const About = (props: AboutProps): JSX.Element => {

const [images] = React.useState<any[]>([
    {
      id: 1,
      src: 'https://images.unsplash.com/photo-1506744038136-46273834b3fb',
      alt: 'Mountain landscape',
      title: 'Beautiful Mountains',
      description: 'A breathtaking view of snow-capped mountains during sunset'
    },
    {
      id: 2,
      src: 'https://images.unsplash.com/photo-1519681393784-d120267933ba',
      alt: 'Forest path',
      title: 'Enchanted Forest',
      description: 'Sunlight filtering through tall trees in a magical forest'
    },
    {
      id: 3,
      src: 'https://images.unsplash.com/photo-1501785888041-af3ef285b470',
      alt: 'Beach sunset',
      title: 'Tropical Paradise',
      description: 'Golden hour at a pristine beach with crystal clear water'
    },
    {
      id: 4,
      src: 'https://images.unsplash.com/photo-1475924156734-496f6cac6ec1',
      alt: 'City skyline',
      title: 'Urban Majesty',
      description: 'Modern city skyline during blue hour'
    },
    {
      id: 5,
      src: 'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b',
      alt: 'Northern lights',
      title: 'Aurora Borealis',
      description: 'Dancing northern lights in the arctic sky'
    }
  ]);

  const handleSlideChange = (index: number) => {
    console.log('Slide changed to:', index);
  };

    const navigate = useNavigate()

    const containerStyle = {
        padding: '10px 40px'
    }

    const handleBack = () => {
        navigate(-1)
    }

    const mainToolbarContent = (
        <ApplicationMainToolbarContent
            title={`About`}
            back={{
                callback:handleBack
            }}
        />
    )
    
    useDynamicMainToolbar(mainToolbarContent, [])

    return (
        <>
            <Paper elevation={3} >
                <Box sx={containerStyle}>
                        <LogoIcon sx={{
                            width: 'auto',
                            height: '32px'
                        }}
                    />
                </Box>       
                <Divider></Divider>
                <Box sx={containerStyle}>
                    <Box>
                        Version {process.env.REACT_APP_VERSION || "-"}
                    </Box>
                    

                    <ImageSlider2
                        images={images}
                        autoPlay={true}
                        autoPlayInterval={4000}
                        showDots={true}
                        showArrows={true}
                        showThumbnails={true}
                        infinite={true}
                        transitionDuration={400}
                        onSlideChange={handleSlideChange}
                        />



                </Box>  

            </Paper>

        </>
    )
}